import React from 'react';
import background from '../../assets/albacore.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoAlbacore extends React.Component {
  render () {
    return(


    <ReusableInfoCard     

    tag="OCEANS"
    subtag="OVERFISHED"
    description="Albacore Tuna"
        
    paragraph="Albacore, one of the two main canned tuna species, are threatened by overfishing. Many people depend on this fishery for their livelihood, and nutrition."
    
    background= {background}
    />
  
  );
 }
}
export default InfoAlbacore;